import React, { useCallback, useState } from 'react';
import { Sparkles, Hammer } from 'lucide-react';

// "Coming in the next build wave" panel. Rendered inline when a screen's
// deeper backend isn't built yet, so no button silently does nothing.
export function ComingWave({ title, children, tag = 'Next build wave' }) {
  return (
    <div className="ci-wave" role="note">
      <div className="ci-wic"><Hammer size={18} /></div>
      <div>
        <div className="ci-wt">{title}</div>
        <div className="ci-wp">{children}</div>
        <span className="ci-wtag">{tag}</span>
      </div>
    </div>
  );
}

// Tiny ephemeral toast. Used to confirm that a not-yet-wired action was
// acknowledged ("noted — coming in the next build wave"), or that a wired
// action succeeded. Auto-dismisses.
export function Toast({ message, onDone }) {
  if (!message) return null;
  return (
    <div className="ci-toast" role="status" onAnimationEnd={undefined}>
      <Sparkles size={16} className="ci-tspark" />
      <span>{message}</span>
    </div>
  );
}

export function useToast() {
  const [message, setMessage] = useState('');
  const show = useCallback((msg, ms = 2600) => {
    setMessage(msg);
    window.clearTimeout(useToast._t);
    useToast._t = window.setTimeout(() => setMessage(''), ms);
  }, []);
  const node = <Toast message={message} />;
  return { show, node };
}

// Loading row + error fallback used by every data-backed screen so a failed
// call degrades gracefully instead of crashing.
export function Loading({ label = 'Loading…' }) {
  return (
    <div className="ci-loading"><span className="ci-spinner" />{label}</div>
  );
}

export function ErrorFallback({ message = 'Could not load this right now.', onRetry }) {
  return (
    <div className="ci-wave" role="alert">
      <div className="ci-wic">!</div>
      <div>
        <div className="ci-wt">Something went wrong</div>
        <div className="ci-wp">{message}</div>
        {onRetry && (
          <button className="ci-btn ci-sm" style={{ marginTop: 8 }} onClick={onRetry}>Try again</button>
        )}
      </div>
    </div>
  );
}
